import React from 'react';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import PropTypes from 'prop-types';
import { isPresent } from 'utils/isPresent';

import AppDetails from '../../Apps/AppDetailsStrategies';

import AppStoreIcon from './AppStoreIcon';

const useStyles = makeStyles(() => ({
  iconShape: {
    maxHeight: 50,
    minWidth: 50,
    maxWidth: 70,
    height: '100%',
  },
}));

const getAppInfo = (appName) => AppDetails[appName].previewInfo;

const AppsShortcuts = ({ apps, onAppClick }) => {
  const { iconShape } = useStyles();

  const appIcon = (app, appInfo) => {
    if (isPresent(app.image_url)) {
      return (
        <img
          src={app.image_url}
          className={iconShape}
          alt={appInfo.name}
        />
      );
    }

    return React.cloneElement(
      appInfo.iconSvg,
      { className: iconShape, color: 'secondary' },
    );
  };

  return (
    <Grid container justifyContent="center">
      {
        apps.map((app) => {
          const appInfo = getAppInfo(app.app.toLowerCase());

          return (
            <Grid item xs={4} key={appInfo.name}>
              <AppStoreIcon
                linkToApp={app.link_to_app}
                appName={appInfo.name}
                appImage={appIcon(app, appInfo)}
                onClick={onAppClick}
              />
            </Grid>
          );
        })
      }
    </Grid>
  );
};

AppsShortcuts.propTypes = {
  apps: PropTypes.arrayOf(PropTypes.object),
  onAppClick: PropTypes.func.isRequired,
};

export default AppsShortcuts;
